export default {"src":"/_next/static/media/nerd-slateus.042be4dd.svg","height":100,"width":100};